import React from "react";
import get from "lodash/get";
import EntitlementUpgradePrompt from "components/EntitlementUpgradePrompt";
import { UPGRADE_FEATURE_PROMPT_MAP } from "constants/upgrade";
import { usePriceBlocsContext } from "@priceblocs/react-priceblocs-js";

const EntitlementsUpgradeContainer = (props) => {
  const ctx = usePriceBlocsContext();
  if (!ctx || !ctx.values || !ctx.values.entitlements) {
    return null;
  }

  let content = null;
  const entitlements = ctx.values.entitlements || {};
  const featureKeys =
    props && props.features ? props.features : Object.keys(entitlements);

  for (
    let featureKeyIx = 0;
    featureKeyIx < featureKeys.length;
    featureKeyIx++
  ) {
    const featureKey = featureKeys[featureKeyIx];
    const entitlement = entitlements[featureKey];
    const prompt = UPGRADE_FEATURE_PROMPT_MAP[featureKey];
    const showPrompt = get(entitlement, "upgrade.price") && prompt;

    if (showPrompt) {
      content = (
        <EntitlementUpgradePrompt
          {...prompt}
          component={props.component}
          customClasses={props.customClasses}
          uid={featureKey}
          entitlement={entitlement}
        />
      );
      break;
    }
  }

  return content
    ? props.children
      ? props.children(content)
      : content
    : content;
};

export default EntitlementsUpgradeContainer;
